import { useEffect } from "react";
import { useAuthorization } from "../Auth/AuthorizationProvider";

const MANIFEST_HREF = "/manifest.webmanifest";
const MANIFEST_ELEMENT_ID = "pwa-manifest-link";

/**
 * Adds the web app manifest, which is what makes the browser offer to install
 * the portal as an app.
 *
 * Withheld until the user is authorized so the install affordance does not
 * appear on the sign-in page. The manifest cannot be gated on the server: it is
 * a static file served by IIS before any authentication happens, so the link is
 * injected on the client and kept out of the initial HTML.
 */
export function ManifestLink() {
    const { isAuthorized } = useAuthorization();

    useEffect(() => {
        const existing = document.getElementById(MANIFEST_ELEMENT_ID);

        if (!isAuthorized) {
            // Also covers sign-out.
            existing?.remove();
            return;
        }

        if (existing) return;

        const link = document.createElement("link");
        link.id = MANIFEST_ELEMENT_ID;
        link.rel = "manifest";
        link.href = MANIFEST_HREF;
        document.head.appendChild(link);
    }, [isAuthorized]);

    return null;
}

export default ManifestLink;
